import React, { useContext } from "react";

import "../../styles/Omaha.css";
import {
  OmahaContext,
  OmahaActionTypes,
  OMAHA_HOLE_CARDS,
  isComplete
} from "../../context/omahaStore";
import { SHORT_PLAYER_NAMES } from "../../constants";
import PlayerStrip, { HandSlots } from "./PlayerStrip";
import DeckPicker from "./DeckPicker";
import OmahaRail from "./OmahaRail";
import OmahaSeoContent, { OmahaMetaTags } from "./OmahaSeo";

// Exact-hand Omaha: every seat is one four-card combo, so no range expansion
// is involved — this is the slice the equity API already accepts as-is.
export default function OmahaCalculator(props) {
  const [state, dispatch] = useContext(OmahaContext);
  const hand = state.hands[state.selected] || [];
  const remaining = OMAHA_HOLE_CARDS - hand.length;

  return (
    <div className="omahaLayout">
      <OmahaMetaTags />
      <div>
        <div className="omahaSection">
          <span className="omahaLabel">Players</span>
          <PlayerStrip />
        </div>

        <div className="omahaSection">
          <span className="omahaLabel">
            {SHORT_PLAYER_NAMES[state.selected]} hand
          </span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <HandSlots
              hand={hand}
              onRemove={card =>
                dispatch({ type: OmahaActionTypes.UNPICK_CARD, card })
              }
            />
            <span className="handSlotHint">
              {isComplete(hand)
                ? "4 of 4 — click a card to remove it"
                : remaining + (remaining === 1 ? " more card" : " more cards")}
            </span>
            {hand.length ? (
              <button
                type="button"
                className="removePlayer"
                onClick={() => dispatch({ type: OmahaActionTypes.CLEAR_HAND })}
              >
                clear
              </button>
            ) : null}
          </div>
        </div>

        <div className="omahaSection">
          <span className="omahaLabel">Deck</span>
          <DeckPicker />
        </div>
      </div>

      <OmahaRail />
      <OmahaSeoContent />
    </div>
  );
}
